import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { TranslateService } from '@ngx-translate/core';
import { loadStripe } from '@stripe/stripe-js';
import mapboxgl from 'mapbox-gl';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { SeoService } from 'src/app/seo.service';
import { CommonService } from 'src/app/services/common.service';
import { UiSpinnerService } from 'src/app/services/ui-spinner.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { icon } from 'src/consts/icon';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { SUPERADMIN_ROUTES, WEB_ROUTES } from 'src/consts/routes';
import { sweetAlert } from 'src/consts/sweet_alert';
import { longDate, showNotification, swalWithBootstrapButtons } from 'src/consts/utils';
import { configData } from 'src/environments/configData';
import { environment } from 'src/environments/environment';
import { DialogContentComponent } from './dialog-content-component/dialog-content-component';
import { httpVersion, superAdminRoutes } from 'src/consts/http-routes';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-company-registration-form',
  templateUrl: './company-registration-form.component.html',
  styleUrls: ['./company-registration-form.component.scss'],
  standalone: false
})
export class CompanyRegistrationFormComponent extends UnsubscribeOnDestroyAdapter {
  id = '';
  isDelete = 0;
  registerForm: UntypedFormGroup;
  trialRegisterForm: UntypedFormGroup;
  year: number = new Date().getFullYear();
  range: Array<number> = [];
  companyLogo: any = icon.LOGO_PLACEHOLDER;

  currencyList = configData.CURRENCY_LIST;
  languageList = configData.LANGUAGE_ARRAY;
  @ViewChild('OpenFilebox') OpenFilebox: any;
  isImageSaved = false;
  cardImageBase64: any;
  filepath = '';
  statusList = configData.Status;
  status: any = configData.superAdminStatus;
  //card add variables
  stripe: any;
  elements: any;
  card: any;
  clientSecret: any
  emailValid: boolean | null = null;
  emailErrorMessage: string | null = null;
  einValid: boolean | null = null;
  einErrorMessage: string | null = null;
  locationData: any = {
    location_name: "",
    location_street1: "",
    location_street2: "",
    location_city: "",
    location_state: "",
    location_postcode: "",
    location_country: "",
    location_lat: "",
    location_lng: "",
  };
  is_ask_for_location: boolean = false;
  location_lat = "";
  location_lon = "";
  min: number = configData.POSTAL_CODE_MIN;
  max: number = configData.POSTAL_CODE_MAX;
  planData: any
  price: any
  stripeInitialized = false;
  isBillingChecked = false;
  isTermsChecked = false;
  isPrivacyChecked = false;
  isTermsDialogAccepted = false;
  isPrivacyDialogAccepted = false;
  @ViewChild('stepper') stepper!: MatStepper;
  is_show: boolean = false;
  plan: any;

  isScrolledToBottom = false;
  payment_mothed_id: any
  customer_id: any;
  subscription_id: any;
  isTrial: boolean = false;

  isLoading = false;
  // Constructor class
  constructor(private seo: SeoService, public dialog: MatDialog, private snackBar: MatSnackBar, public route: ActivatedRoute,
    private router: Router, private commonService: CommonService, public translate: TranslateService, private deviceService: DeviceDetectorService,
    public uiSpinner: UiSpinnerService, private fb: UntypedFormBuilder, private http: HttpClient) {
    super();
    this.seo.setTags({
      title: 'Company Registration Form', // Title
      titleSuffix: '- SmartAccuPay', // Title Suffix
      description: 'SmartAccuPay Invoice Management', // Description
      image: '', // Image
      keywords: 'SmartAccuPay' // Keywords
    });
    this.id = this.route.snapshot.queryParamMap.get('_id') ?? '';
    this.registerForm = this.fb.group({
      companyname: ['', [Validators.required]],
      companyemail: ['', [Validators.required, Validators.email]],
      companyphone: ['', [Validators.required]],
      companyein: [''],
      companyactivesince: [this.year, [Validators.required]],
      companyaddress: ['', [Validators.required]],
      companyaddresscity: ['', [Validators.required]],
      companyaddressstate: ['', [Validators.required]],
      companyaddresszip: ['', [Validators.required]],
      conatactpersonfirstname: ['', [Validators.required]],
      conatactpersonlastname: ['', [Validators.required]],
      auto_fill_billing: [false],
      billingpersonaddress: ['', [Validators.required]],
      billingpersoncity: ['', [Validators.required]],
      billingpersonstate: ['', [Validators.required]],
      billingpersonzipcode: ['', [Validators.required]]
    });
    this.trialRegisterForm = this.fb.group({
      companyname: ['', [Validators.required]],
      companyemail: ['', [Validators.required, Validators.email]],
      companyphone: ['', [Validators.required]],
      companyein: [''],
      companyactivesince: [''],
      companyaddress: [''],
      companyaddresscity: [''],
      companyaddressstate: [''],
      companyaddresszip: [''],
      conatactpersonfirstname: ['', [Validators.required]],
      conatactpersonlastname: ['', [Validators.required]],
      auto_fill_billing: [false],
      billingpersonaddress: [''],
      billingpersoncity: [''],
      billingpersonstate: [''],
      billingpersonzipcode: ['']
    });

    this.getGIF();
    this.registerForm.get('auto_fill_billing')!.valueChanges.subscribe(value => {
      this.toggleBillingAddress(value);
    });

    // Setup live validation for companyemail
    this.registerForm.get('companyemail')?.valueChanges
      .pipe(
        debounceTime(500), // Wait 500ms after user stops typing
        distinctUntilChanged(), // Only call API if value has changed
        switchMap((value) => this.checkEmail(value))
      )
      .subscribe((response) => {
        if (!response.status) {
          this.registerForm.get('companyemail')?.setErrors({ customError: response.message });
        } else {
          this.registerForm.get('companyemail')?.setErrors(null); // Clear errors
        }
      });

    // Setup live validation for companyein
    this.registerForm.get('companyein')?.valueChanges
      .pipe(
        debounceTime(500), // Wait 500ms after user stops typing
        distinctUntilChanged(), // Only call API if value has changed
        switchMap((value) => this.checkIn(value))
      )
      .subscribe((response) => {
        if (!response.status) {
          this.registerForm.get('companyein')?.setErrors({ customError: response.message });
        } else {
          this.registerForm.get('companyein')?.setErrors(null); // Clear errors
        }
      });

    this.registerForm.get('companyname')?.valueChanges
      .pipe(
        debounceTime(500), // Wait 500ms after user stops typing
        distinctUntilChanged(), // Only call API if value has changed
        switchMap((value) => this.checkCompanyName(value))
      )
      .subscribe((response) => {
        if (!response.status) {
          this.registerForm.get('companyname')?.setErrors({
            customError: { message: response.message }
          });
        } else {
          this.registerForm.get('companyname')?.setErrors(null);
        }
      });



    // Subscribe to value changes and update the first character
    this.registerForm.get('username')?.valueChanges.subscribe(value => {
      if (value) {
        this.registerForm.patchValue({
          username: value.charAt(0).toUpperCase() + value.slice(1)
        }, { emitEvent: false });
      }
    });
    for (let i = 0; i < 100; i++) {
      this.range.push(this.year - i);
    }

  }
  ngAfterViewInit() {
    this.initializeGeocoder();
    this.initializeStripe();
    const iframe = document.querySelector('.terms-iframe') as HTMLElement;
    iframe.addEventListener('scroll', () => {
      if (iframe.scrollHeight - iframe.scrollTop <= iframe.clientHeight) {
        this.isScrolledToBottom = true;
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const encryptedPlan = params.get('plan');

      if (encryptedPlan) {
        // Decode the base64-encoded plan name
        this.plan = atob(encryptedPlan);  // Use `atob()` for base64 decoding
        this.getPlaneDetails();
      }
    });

    if (this.plan == "Free Trial") {
      this.isTrial = true
    } else {
      this.isTrial = false
    }


  }
  onStepChange(event: StepperSelectionEvent) {
    if (event.selectedIndex === 1 && !this.stripeInitialized) {
      this.mountStripeCard(); // Mount card element only when Payment Details step is active
      this.stripeInitialized = true; // Ensure it only happens once
    }
  }

  initializeGeocoder() {
    (mapboxgl as typeof mapboxgl).accessToken = configData.MAPBOXAPIKEY;

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      types: "address",
    });
    geocoder.addTo("#geocoder-container");
    let that = this;
    geocoder.on("result", (params: any) => {
      this.is_ask_for_location = true;
      if (
        (params.result.geometry.coordinates != undefined ||
          params.result.geometry.coordinates != null) && this.locationData != undefined
      ) {
        this.locationData.location_lat = params.result.geometry.coordinates[1];
        this.locationData.location_lng = params.result.geometry.coordinates[0];
        this.location_lat = params.result.geometry.coordinates[1];
        this.location_lon = params.result.geometry.coordinates[0];
      }

      params.result.context.forEach((element: any, index: number) => {
        if (typeof params.result.context[index] !== "undefined") {
          if (params.result["properties"]["address"] !== -1) {
            that.registerForm.get("client_address")?.setValue(params.result["properties"]["address"]);
            this.locationData.location_street1 = params.result["properties"]["address"];
          }


          if (params.result["text"] !== -1) {
            var tempAddress = params.result["text"];
            if (params.result["address"] !== -1) {
              if (params.result["address"] != null && params.result["address"] != undefined && params.result["address"] != '') {
                tempAddress = `${params.result["address"]} ${params.result["text"]}`.trim();
              }
            }
            this.registerForm.get("companyaddress")?.setValue(tempAddress);
            this.locationData.location_street1 = tempAddress;
          }

          if (params.result.context[index].id.indexOf("postcode") !== -1) {
            this.registerForm.get("companyaddresszip")?.setValue(params.result.context[index].text);
            this.locationData.location_postcode = params.result.context[index].text;
          }

          if (params.result.context[index].id.indexOf("place") !== -1) {
            this.registerForm.get("companyaddresscity")?.setValue(params.result.context[index].text);
            this.locationData.location_city = params.result.context[index].text;
          }

          if (params.result.context[index].id.indexOf("region") !== -1) {
            this.registerForm.get("companyaddressstate")?.setValue(params.result.context[index].text);
            this.locationData.location_state =
              params.result.context[index].text;
          }
        }
      });
    });
  }

  async initializeStripe() {
    this.stripe = await loadStripe(environment.STRIPE_KEY);
    if (this.stripe) {
      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');
    } else {
      console.error('Stripe failed to initialize');
    }
  }

  mountStripeCard() {
    if (this.card) {
      const cardElement = document.getElementById('card-element');
      if (cardElement) {
        this.card.mount(cardElement);
      } else {
        console.error('#card-element not found');
      }
    }
  }

  toggleBillingAddress(isAutoFill: any): void {
    if (isAutoFill) {
      this.registerForm.patchValue({
        billingpersonaddress: this.registerForm.get('companyaddress')!.value,
        billingpersoncity: this.registerForm.get('companyaddresscity')!.value,
        billingpersonstate: this.registerForm.get('companyaddressstate')!.value,
        billingpersonzipcode: this.registerForm.get('companyaddresszip')!.value
      });
    }


  }

  validateNumericInput(event: KeyboardEvent): boolean {
    const charCode = event.charCode;
    return charCode >= 48 && charCode <= 57; // Allows only numbers
  }

  areClientFieldsFilled(): boolean {
    const clientAddressFields = [
      'companyaddress',
      'companyaddresscity',
      'companyaddressstate',
      'companyaddresszip'
    ];

    return clientAddressFields.every(field => this.registerForm.get(field)!.valid);
  }

  checkEmail(email: string) {
    return this.commonService.postRequestWithoutTokenAPI(
      `${httpVersion.SUPERADMIN_V1}${superAdminRoutes.CHECK_EMAIL}`,
      { companyemail: email }
    );
  }

  checkCompanyName(name: string) {
    return this.commonService.postRequestWithoutTokenAPI(
      `${httpVersion.SUPERADMIN_V1}${superAdminRoutes.CHECK_COMPANY_NAME}`,
      { companyname: name }
    );
  }

  checkIn(ein: string) {
    return this.commonService.postRequestWithoutTokenAPI(
      `${httpVersion.SUPERADMIN_V1}${superAdminRoutes.CHECK_IN}`,
      { companyein: ein }
    );
  }

  getPlaneDetails() {
    this.commonService.postRequestWithoutTokenAPI(
      httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_PLAN_DETAILS,
      { plan: this.plan }
    ).subscribe((data) => {
      this.planData = data.data;
      this.price = Number(this.planData.price).toFixed(2); // Ensure two decimal places
    });
  }
  openDialog(type: 'terms' | 'privacy', event: MouseEvent): void {
    if (type === 'terms')
      this.isTermsChecked = false;
    if (type === 'privacy')
      this.isPrivacyChecked = false;
    event.stopPropagation(); // Prevent interference from parent elements
    const url =
      type === 'terms'
        ? 'https://www.rovuk.com/mobile-terms-of-service-2'
        : 'PRIVACY_POLICY_CONTENT';

    const dialogRef = this.dialog.open(DialogContentComponent, {
      width: '600px',
      data: { type, url, planData: this.planData },
      panelClass: 'rounded-dialog'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'accepted' && type === 'terms') {
        this.isTermsDialogAccepted = true;
        this.isTermsChecked = true;
      } else if (result === 'accepted' && type === 'privacy') {
        this.isPrivacyDialogAccepted = true;
        this.isPrivacyChecked = true;
      }
    });
  }
  async getGIF() {
    let that = this;
    const data = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_GIF);
    if (data.status) {
      if (data.data != null) {
        that.companyLogo = data.data.image_url;
        localStorage.setItem("smartaccupay-logo", data.data.image_url);
        localStorage.setItem("smartaccupay-gif", data.data.gif_url);
      }
    }
  }

  getCardDetails() {
    this.commonService.postRequestWithoutTokenAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_CARD_DETAILS, { paymentMethodId: "pi_3QNB0nA7sdz0RNEe03NsQD51" }).subscribe((data) => {
      console.log("data", data);
    });

  }

  async createPaymentIntent(amount: number): Promise<void> {
    this.uiSpinner.spin$.next(true);
    // Determine the payment type based on the plan
    const isRecurring = this.planData.payment_method === 'recurring';
    const dynamicPlan = this.planData.duration;

    // Convert the amount from dollars to cents
    const amountInCents = Math.round(amount * 100);

    // Request payload for the backend
    const paymentPayload: any = {
      amount: amountInCents,
      name: this.registerForm.get('companyname')?.value || '',
      email: this.registerForm.get('companyemail')?.value || '',
    };

    // Add the `plan` key only if it's not Lifetime
    if (dynamicPlan) {
      paymentPayload.plan = dynamicPlan; // Add dynamic plan for Monthly or Yearly
    }

    // Add the `paymentType` key only if it's recurring
    if (isRecurring) {
      paymentPayload.paymentType = 'recurring';
    }

    paymentPayload.stripe_price_id = this.planData.stripe_price_id;
    paymentPayload.stripe_product_id = this.planData.stripe_product_id;

    // Generate a token
    const { token, error } = await this.stripe.createToken(this.card,
      {
        name: this.registerForm.get('companyname')?.value || '',
        email: this.registerForm.get('companyemail')?.value || '',
        address_line1: this.registerForm.get('billingpersonaddress')?.value || '',
        address_city: this.registerForm.get('billingpersoncity')?.value || '',
        address_state: this.registerForm.get('billingpersonstate')?.value || '',
        address_zip: this.registerForm.get('billingpersonzipcode')?.value || ''
      });

    if (error) {
      console.error('Error creating token:', error.message);
      this.dialog.open(ErrorDialogComponent, {
        data: { message: error.message },
        panelClass: 'rounded-dialog'
      });
      this.uiSpinner.spin$.next(false);
      return; // Exit if token creation fails
    }

    if (token) {
      paymentPayload.token = token.id; // Include the token in the payload
    }

    // Make a request to the backend to create a payment intent
    this.http.post<{ data: any; clientSecret: any }>(
      httpVersion.SUPERADMIN_V1 + superAdminRoutes.CREATE_PAYMENT,
      paymentPayload
    ).subscribe(
      (response) => {
        if (response.data) {
          this.clientSecret = response.data.clientSecret;
          this.customer_id = response.data.customer_id;
          this.subscription_id = response.data.subscription;
        } else {
          this.clientSecret = response.clientSecret;
        }

        // After receiving the client secret, directly call handlePayment
        this.handlePayment();
      },
      (error) => {
        this.uiSpinner.spin$.next(false);
        console.error('Error creating payment intent:', error);
      }
    );
  }




  async handlePayment(): Promise<void> {
    if (!this.clientSecret) {
      console.error('No client secret available');
      this.dialog.open(ErrorDialogComponent, {
        data: { message: 'No client secret available.' },
        panelClass: 'rounded-dialog'
      });
      return;
    }

    const { error, paymentIntent } = await this.stripe.confirmCardPayment(this.clientSecret, {
      payment_method: {
        card: this.card, // Stripe Element instance
        billing_details: {
          name: this.registerForm.get('companyname')?.value || '',
          email: this.registerForm.get('companyemail')?.value || '',
          phone: this.registerForm.get('companyphone')?.value || '',
          address: {
            line1: this.registerForm.get('billingpersonaddress')?.value || '',
            city: this.registerForm.get('billingpersoncity')?.value || '',
            state: this.registerForm.get('billingpersonstate')?.value || '',
            postal_code: this.registerForm.get('billingpersonzipcode')?.value || '',

          },
        },
      },
    });

    if (error) {
      this.uiSpinner.spin$.next(false);
      console.error('Payment error:', error.message);
      // Open error dialog
      this.dialog.open(ErrorDialogComponent, {
        data: { message: error.message },
        panelClass: 'rounded-dialog'
      });
    } else if (paymentIntent) {
      switch (paymentIntent.status) {
        case 'succeeded':
          this.snackBar.open('Successful Payment', 'Close', { duration: 3000, panelClass: 'success-snackbar' });
          this.uiSpinner.spin$.next(false);
          this.saveRegister();
          this.payment_mothed_id = paymentIntent.payment_method, this.customer_id = this.customer_id
          // Save payment details to localStorage
          const paymentDetails = {
            cardLast4: paymentIntent.payment_method_details?.card?.last4 || 'N/A', // Last 4 digits of the card
            amountPaid: (paymentIntent.amount / 100).toFixed(2), // Convert cents back to dollars
            currency: paymentIntent.currency.toUpperCase(),
            timestamp: new Date().toISOString(), // ISO timestamp for accurate recording
          };
          localStorage.setItem('paymentDetails', JSON.stringify(paymentDetails));

          break;

        case 'requires_payment_method':
          this.dialog.open(ErrorDialogComponent, {
            data: { message: 'Card Declined or Insufficient Funds' },
            panelClass: 'rounded-dialog'
          });
          this.uiSpinner.spin$.next(false);
          break;

        case 'requires_action':
          this.dialog.open(ErrorDialogComponent, {
            data: { message: 'Authentication Required' },
            panelClass: 'rounded-dialog'
          });
          this.uiSpinner.spin$.next(false);
          break;

        default:
          this.dialog.open(ErrorDialogComponent, {
            data: { message: 'Payment failed or an unexpected status occurred.' },
            panelClass: 'rounded-dialog'
          });
          this.uiSpinner.spin$.next(false);
      }
    }
  }


  // Confirmation dialog for form save
  confirmExit() {
    if (this.registerForm.dirty) {
      swalWithBootstrapButtons
        .fire({
          title: this.translate.instant('SUPERADMIN.AGENT.CONFIRMATION_DIALOG.SAVING'),
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: this.translate.instant('COMMON.ACTIONS.SAVE_EXIT'),
          cancelButtonText: this.translate.instant('COMMON.ACTIONS.DO_NOT_SAVE'),
          denyButtonText: this.translate.instant('COMMON.ACTIONS.CANCEL'),
          allowOutsideClick: false,
          background: localStorage.getItem(localStorageConstants.DARKMODE) === 'dark' ? sweetAlert.DARK_BACKGROUND : sweetAlert.WHITE_BACKGROUND,
          color: localStorage.getItem(localStorageConstants.DARKMODE) === 'dark' ? sweetAlert.DARK_COLOR : sweetAlert.WHITE_COLOR,
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (this.registerForm.valid) {
              this.saveRegister();
            }
          } else if (result.isDenied) {

          } else {
            this.back();
          }
        });
    }
    else {
      this.back();
    }
  }

  // Back action to navigate to previous page
  back() {
    this.router.navigate([SUPERADMIN_ROUTES.AGENT], { queryParams: { isDelete: this.isDelete } });
  }
  openLogin() {
    this.router.navigate([WEB_ROUTES.LOGIN]);
  }


  // Reset the form
  resetForm() {
    this.registerForm.reset();
  }

  async getDeviceInfo() {
    let new_reqObject = {};
    const userdata = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA) ?? '{}');
    // Prepare new_reqObject with device and location details
    const deviceInfo = this.deviceService.getDeviceInfo();
    return fetch("https://ipinfo.io/json?token=c22c8f2cf5a2b9")
      .then((res) => res.json())
      .then((response) => {
        const lookupInfo = response;
        const loc = lookupInfo["loc"];
        const let_log = loc.split(",");
        new_reqObject = {
          created_date: longDate(new Date()),
          ip_address: lookupInfo["ip"],
          mac_address: "",
          device_type: "Web",
          device_name: `${deviceInfo["device"]} ${deviceInfo["deviceType"]}`,
          os: deviceInfo["os"],
          os_version: deviceInfo["os_version"],
          browser: deviceInfo["browser"],
          browser_version: deviceInfo["browser_version"],
          location: `${lookupInfo["city"]}, ${lookupInfo["country"]}, ${lookupInfo["postal"]}`,
          location_lat: let_log[0],
          location_lng: let_log[1],
        }
        return new_reqObject;
      }).catch((e) => {
        console.log("device location error", e);
        return e;
      });
  }

  // Reset the Stripe card
  resetStripeCard() {
    if (this.card) {
      this.card.unmount();  // Unmount the card element
      this.card = this.elements?.create('card');  // Create a new card element
      const cardElement = document.getElementById('card-element');
      if (cardElement && this.card) {
        this.card.mount(cardElement);  // Mount the new card element
      }
    }
  }

  saveTrialRegister() {
    this.uiSpinner.spin$.next(false);
    let that = this;
    if (that.trialRegisterForm.valid) {
      const requestObject = that.trialRegisterForm.value;
      requestObject.plan_details = that.planData;
      requestObject.customer_id = that.customer_id;
      requestObject.subscription_id = that.subscription_id;
      requestObject.is_trial = true;
      that.uiSpinner.spin$.next(true);

      that.trialRegisterForm.valueChanges.subscribe((formValues) => {
        // Check if the values are valid
        if (that.trialRegisterForm.valid) {
          requestObject.contactpersonemail = formValues.companyemail;
          requestObject.contactpersonphone = formValues.companyphone;
        }
      });


      that.commonService.postRequestWithoutTokenAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.SAVE_REGISTRATION_FORM, requestObject).subscribe(async (data) => {
        if (data.status) {
          showNotification(that.snackBar, data.message, 'success');
          that.uiSpinner.spin$.next(false)
          that.dialog.open(SuccessDialogComponent, {
            data: {
              message: `<p><b>Your SmartAccuPay Trial Account has been successfully created.</b> </p>
      <p>You now have access to all the features during your trial period.</p>
      <p>We’ve sent your login credentials to the email address you provided.</p>
      <p>Please check your <b>inbox</b> (and <b>spam/junk folder</b>, just in case) to get started.</p>
      <p>If you need assistance or have any questions, feel free to reach out to our support team.</p>
      <p class="enjoy-text">🎉 Enjoy exploring <b>SmartAccuPay!</b></p>`,
              reSend: true,
              companyData: { ...data.data, tempPassword: data.tempPassword }
            },
          });
          that.router.navigate([WEB_ROUTES.LOGIN]);
          localStorage.removeItem(localStorageConstants.USERDATA);
          localStorage.removeItem(localStorageConstants.COMPANYDATA);
          localStorage.removeItem(localStorageConstants.COMPANYID);
          localStorage.removeItem(localStorageConstants.INVOICE_GIF);
          localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
        } else {
          showNotification(that.snackBar, data.message, 'error');
        }
      });

    }
  }

  // Add or Edit Agent 
  async saveRegister() {
    this.uiSpinner.spin$.next(false);
    let that = this;
    if (that.registerForm.valid) {

      const requestObject = that.registerForm.value;
      requestObject.plan_details = that.planData;
      requestObject.customer_id = that.customer_id;
      requestObject.subscription_id = that.subscription_id;

      requestObject.is_trial = false


      that.registerForm.valueChanges.subscribe((formValues) => {
        // Check if the values are valid
        if (that.registerForm.valid) {
          requestObject.contactpersonemail = formValues.companyemail;
          requestObject.contactpersonphone = formValues.companyphone;
        }
      });
      that.commonService.postRequestWithoutTokenAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.SAVE_REGISTRATION_FORM, requestObject).subscribe(async (data) => {
        that.uiSpinner.spin$.next(false);
        if (data.status) {
          that.dialog.open(SuccessDialogComponent, {
            data: {
              message: `<p><b>Your SmartAccuPay Account has been successfully created.</b></p>
    <p>You now have full access to all features.</p>
    <p>We’ve sent your login credentials to the email address you provided.</p>
    <p>Please check your <b>inbox</b> (and <b>spam/junk folder</b>, just in case).</p>
    <p>If you need any help, our support team is here for you.</p>
    <p class="enjoy-text">🎉 Enjoy exploring <b>SmartAccuPay!</b></p>`,
              reSend: true,
              companyData: { ...data.data, tempPassword: data.tempPassword }
            },
          });
          showNotification(that.snackBar, data.message, 'success');
          that.is_show = true
          let requestBody: any = {
            customerId: that.customer_id,
            dataCompany: data.data
          };
          // call that for deviceDetails
          that.getDeviceInfo().then(response => {
            requestBody.deviceDetails = response;

            //Save in payment details 
            that.savePaymentDetail(requestBody);
          }).catch((e) => {
            //Save in payment details
            that.savePaymentDetail(requestBody);
          });
          // Assume success and reset form and card

        } else {
          showNotification(that.snackBar, data.message, 'error');
        }
      });

    }
  }

  savePaymentDetail(requestBody: any) {
    const url = `${httpVersion.SUPERADMIN_V1}${superAdminRoutes.GET_CARD_DETAILS}`;
    const params = { paymentMethodId: this.payment_mothed_id };
    this.stepper.next();
    this.commonService.postRequestWithPaymentMethodIdAPI(url, requestBody, params).subscribe((response) => {
      if (response.status) {
        this.resetForm();
        this.resetStripeCard()
        //  this.stepper.next();
        console.log("Response Data:", response);
      } else {
        console.error("Error in response:", response);
      }
    });
  }
}



@Component({
  selector: 'app-error-dialog',
  template: `
    <div class="error-dialog">
      <mat-icon class="error-icon" >error</mat-icon>
      <h1 mat-dialog-title class="error-title">Error</h1>
      <div mat-dialog-content class="error-message">
        <p>{{ data.message }}</p>
      </div>
      <div mat-dialog-actions  class="error-actions">
        <button  mat-raised-button color="primary" class="width-set-2" mat-dialog-close>Close</button>
      </div>
    </div>
  `,
  styles: [
    ` .error-dialog {
      text-align: center;
      padding: 20px;
    }
    .error-icon {
      color: red;
      font-size: 48px;
      margin-bottom: 10px;
      height: 60px;
      width: 60px;
    }
    .error-title {
      font-size: 24px;
      font-weight: bold;
      margin: 0;
      color: #d32f2f;
    }
    .error-message p {
      font-size: 16px;
      color: #555;
      margin: 10px 0;
    }
    .error-actions {
      margin-top: 15px;
      display: flex; /* Using flexbox */
      justify-content: center; /* Center the button horizontally */
      align-items: center; /* Center the button vertically if necessary */
    }
    .width-set-2 {
      width: 150px; /* Set a specific width for the button */
    }
    ::ng-deep .rounded-dialog .mat-mdc-dialog-surface {
  border-radius: 20px;
  overflow: hidden;
}
    `,
  ],
  standalone: false
})
export class ErrorDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) { }
}


@Component({
  selector: 'app-success-dialog',
  template: `
    <div class="success-dialog">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h1 mat-dialog-title class="success-title">Success</h1>
      <div mat-dialog-content class="success-message">
        <div [innerHTML]="data.message"></div>
      </div>
      <div mat-dialog-actions class="success-actions">
        <button mat-raised-button color="primary" class="width-set-2 m-auto" mat-dialog-close>Ok</button>
      </div>
      @if (data.reSend) {
        <button mat-raised-button color="primary"class="width-set-2 m-auto" (click)= "reSendCompanyRegistrationEmail()">Resend Email</button>
      }
    </div>
    `,
  styles: [
    `
      .success-dialog {
        text-align: center;
        padding: 20px;
      }
      .success-icon {
        color: green;
        font-size: 48px;
        margin-bottom: 10px;
        height: 60px;
        width: 60px;
      }
      .success-title {
        font-size: 24px;
        font-weight: bold;
        margin: 0;
        color: #388e3c;
      }
      .success-message p {
        font-size: 16px;
        color: #555;
        margin: 10px 0;
      }
      .success-actions {
        margin-top: 15px;
      }
      ::ng-deep .rounded-dialog .mat-mdc-dialog-surface {
  border-radius: 20px;
  overflow: hidden;
}
    `,
  ],
  standalone: false
})
export class SuccessDialogComponent {
  constructor(private snackBar: MatSnackBar, public uiSpinner: UiSpinnerService, @Inject(MAT_DIALOG_DATA) public data: { message: string, reSend?: boolean, companyData?: any }, private commonService: CommonService) { }

  reSendCompanyRegistrationEmail() {
    this.uiSpinner.spin$.next(true);
    const url = `${httpVersion.SUPERADMIN_V1}${superAdminRoutes.reSendCompanyRegistrationMail}`;
    this.commonService.postRequestWithoutTokenAPI(url, this.data.companyData).subscribe((response: any) => {
      if (response.status) {
        showNotification(this.snackBar, response.message, 'success');
      } else {
        showNotification(this.snackBar, response.message, 'success');
      }
      this.uiSpinner.spin$.next(false);
    });
  }
}
